'use strict'

function visibleViewTitle (title) {

  if (typeof title !== 'string') return ''

  return title.trim()
}

module.exports = {
  visibleViewTitle
}
